import { createSelector } from '@ngrx/store';
import { Versions } from '@usimweb/core/models';
import { Helper } from '../helper';

import * as fromFeature from '../reducers';
import * as fromVersions from '../reducers/versions.reducer';
import * as fromRoot from '@usimweb/state/router-store';

export const getVersionsState = createSelector(
  fromFeature.getProductsState,
  (state: fromFeature.DashboardState) => state.versions
);

export const getVersionsEntities = createSelector(getVersionsState, fromVersions.getVersionsEntities);

export const getVersionsFiltered = createSelector(getVersionsState, fromVersions.getVersionsFiltered);

export const getNewVersion = createSelector(getVersionsEntities, (entities) => {
  const versions = Object.keys(entities).map((uuid: string) => entities[uuid as string]);
  const last = versions.pop();

  if (last !== undefined) {
    return last;
  }

  return {} as Versions;
});

// export const getLastVersion = createSelector(getVersionsEntities, (entities) => {
//   const versions = Object.keys(entities).map((uuid: string) => entities[uuid as any]);

//   const version = versions.pop

// })

export const getVersions = createSelector(getVersionsEntities, (entities) => {
  return Object.keys(entities).map((uuid: string) => entities[uuid as any]);
});

export const getVersionById = (uuid: string) => createSelector(getVersionsEntities, (version) => version[uuid]);

// change to return entities[uuid]
export const getVersionsById = (uuid: string) =>
  createSelector(getVersionsEntities, (entities) => {
    const versions = Object.keys(entities)
      .map((uuid: string) => entities[uuid as any])
      .filter((x) => x.uuid === uuid)[0];
    return versions;
  });

// FIX ME filter
export const getAllVersions = createSelector(getVersionsEntities, getVersionsFiltered, (entities, filter) => {
  const versions = Object.keys(entities).map((uuid: string) => entities[uuid as any]);

  return versions;
  // console.log('get filter');
  // console.log(filter);

  let filtered = versions.filter((version) => {
    if (filter.statusFilter === '-') {
      return versions;
    }
    return version.status.overall.toLowerCase().includes(filter.statusFilter);
  });

  filtered = filtered.filter((version) => {
    if (filter.labelFilter === '-') {
      return filtered;
    }

    return version;
    // const label = version.vela.energyLabel;
    // if (label && label.toLocaleLowerCase() == filter.labelFilter) {
    //   return version;
    // } else {
    //   return;
    // }
  });

  const searchText = filter.searchFilter;
  filtered = filtered.filter((version) => {
    // if (version.hasOwnProperty('title')) {
    //   return version.title.toLowerCase().includes(searchText);
    // }
    // FIXME in backend !!!
    // title for foaming version
    // name for vela version
    if (version.hasOwnProperty('title')) {
      return version.title.toLowerCase().includes(searchText);
    }
    return;
  });

  return filtered.sort(function (x, y) {
    return Helper.getTimeStampFromDate(y.created_at) - Helper.getTimeStampFromDate(x.created_at);
  });
});

export const getSelectedVersion = createSelector(
  getVersionsEntities,
  fromRoot.getRouterState,
  (entities, router): Versions => {
    // console.log('params');
    // console.log(router.state.params);
    // console.log(entities);

    if (Object.keys(entities).length > 0) {
      const version = entities[router.state.params['id2']];
      return version;
    }
    return {} as Versions;
  }
);

export const getCurrentVersion = createSelector(getVersionsState, fromVersions.getCurrentVersion);

export const getVersionsLoaded = createSelector(getVersionsState, fromVersions.getVersionsLoaded);

export const getVersionsLoading = createSelector(getVersionsState, fromVersions.getVersionsLoading);
